import React from "react";

const RING_STYLES = {
  1: "text-cyan-400 bg-cyan-400/10 border border-cyan-400/20",
  2: "text-fuchsia-400 bg-fuchsia-400/10 border border-fuchsia-400/20",
  3: "text-amber-400 bg-amber-400/10 border border-amber-400/20",
};

const RING_LABELS = {
  1: "RING 1 · TERMINAL",
  2: "RING 2 · SKIT",
  3: "RING 3 · NARRATIVE",
};

export default function RingBadge({ ring, className = "" }) {
  return (
    <span
      data-testid={`ring-badge-${ring}`}
      className={`font-mono text-[10px] uppercase tracking-widest px-2 py-0.5 rounded-sm ${RING_STYLES[ring] || RING_STYLES[3]} ${className}`}
    >
      {RING_LABELS[ring] || RING_LABELS[3]}
    </span>
  );
}
